import React from "react";
import { motion } from "framer-motion";

const ScrollReveal = ({ children, delay = 0, y = 60 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -150px 0px" }}
      style={{ willChange: "opacity, transform" }}
      transition={{
        duration: 1.1,
        delay: delay,
        ease: [0.21, 0.45, 0.32, 0.9],
      }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
